import { initMap } from "./map";
export default function initModalMap() {
    let leagueCards = document.querySelectorAll('.item-league-card');

    // check we have league cards on load.
    if(leagueCards) {
        leagueCards.forEach((card) => {
            let viewLink = card.querySelector('.modal-link');
            viewLink.addEventListener('click', function(){
                console.log('view modal clicked');
                renderModalMaps(viewLink.dataset.bsTarget);
            })
        })
    }
}

// fetch and render maps from lat long data for each map location
function renderModalMaps(modalId) {
    let modal = document.querySelector(modalId);

    if(modal) {
        let maps = modal.querySelectorAll('.map');
        //console.log(maps);

        maps.forEach((map) =>{
            //console.log(map)

            // use exisiting init map function
            initMap(map);
            
        })
    }

}